export class ErrorsUtils {
    public static isAuth0TenantLimitReachedErrors(message: string): boolean {
        const keywords = ["reached", "limit", "tenant"];
        return keywords.filter((keyword) => message?.includes(keyword)).length === keywords.length;
    }
}
